var React = require('react');

function DifficultyLevelGreen (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#4CA252"},React.createElement("circle",{"cx":"10.5","cy":"10.5","r":"10.5"}))));
}

DifficultyLevelGreen.defaultProps = {"role":"presentation","viewBox":"0 0 21 21","version":"1.1"};

module.exports = DifficultyLevelGreen;

DifficultyLevelGreen.default = DifficultyLevelGreen;
